<app-custom-spinner *ngIf="isLoading"></app-custom-spinner>
  <form [formGroup]="cardFormGroup" [style.display]="hasPaymentMethod ? 'none':'initial'" class="stripe-form">
    <div class="stripe-input-container mb-1">
      <div>
        <label>{{ "EDIT_PAYMENT.card_editpayment" | translate }}</label>
        <div class="card-input" id="card-number"></div>
      </div>
      <small [class.transparent]="!cardNumberError" class="stripe-error-hint">
        {{ cardNumberError }}
      </small>
    </div>
    <div class="stripe-input-container mb-1">
      <div>
        <label>{{ "EDIT_PAYMENT.expiration_editpayment" | translate }}</label>
        <div class="expiration-input" id="expiration-date"></div>
      </div>
      <small [class.transparent]="expirationDateError === null" class="stripe-error-hint">
        {{ expirationDateError }}
      </small>
    </div>
    <div class="stripe-input-container mb-1">
      <div>
        <label>{{ "EDIT_PAYMENT.cvv_editpayment" | translate }}</label>
        <div class="cvc-input" id="cvc-number"></div>
      </div>
      <small [class.transparent]="!cvcError" class="stripe-error-hint">
        {{ cvcError }}
      </small>
    </div>
  </form>
